window.onload = () => {
  const loadScreen = document.getElementById("load-screen");
  loadScreen.classList.add("loaded");
};
